module.exports = __webpack_public_path__ + "media/bootstrap-icons/clipboard-minus-52ba0b92.svg";